import { sdk } from "@gc/ipecs-web-sdk";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

const useCallInsights = () => {
  const { callLog } = sdk;
  const [callInsights, setCallInsights] = useState();

  const CallInsightsQuery = useQuery(
    ["insights-call-logs"],
    () => {
      return callLog.getCallLogs(1000);
    },
    {
      keepPreviousData: true,
      cacheTime: 3600000, // one hour
      staleTime: 600000, // 10 mins
    },
  );

  useEffect(() => {
    if (!CallInsightsQuery?.data) return;

    const callLogsData = CallInsightsQuery.data.callLogs.map((x) => ({
      ...x,
      durationSeconds: Math.round(x.callDuration / 1000),
      callDirection: ["confirmed", "missed", "incoming"].includes(x.type)
        ? "incoming"
        : "outgoing",
    }));

    const secondsToMMSS = (seconds) => {
      const roundedSeconds = Math.round(seconds);
      return `${Math.floor(roundedSeconds / 60)}:${(roundedSeconds % 60)
        .toString()
        .padStart(2, "0")}`;
    };

    const getSplitPercent = (totalCount, count) => {
      if (totalCount === 0) return "N/A";

      return `${Math.round((count / totalCount) * 100, 1)}%`;
    };

    const totalCount = callLogsData.length;
    const totalCallCountWithDuration = callLogsData.filter(
      (x) => x.durationSeconds > 0,
    ).length;
    const incomingCount = callLogsData.filter(
      (x) => x.callDirection === "incoming",
    ).length;
    const outgoingCount = callLogsData.filter(
      (x) => x.callDirection === "outgoing",
    ).length;

    const totalDurationSeconds = callLogsData.reduce(
      (total, call) => total + call.durationSeconds,
      0,
    );

    const callInsights = {
      count: totalCount,
      total_duration: secondsToMMSS(totalDurationSeconds),
      average_duration: secondsToMMSS(
        totalDurationSeconds / totalCallCountWithDuration,
      ),
      incoming: {
        count: incomingCount,
        percent: getSplitPercent(totalCount, incomingCount),
      },
      outgoing: {
        count: outgoingCount,
        percent: getSplitPercent(totalCount, outgoingCount),
      },
    };

    setCallInsights(callInsights);
  }, [CallInsightsQuery?.data]);
  const getUpdatedAt = () =>
    new Date(CallInsightsQuery.dataUpdatedAt).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

  return {
    callInsights,
    getUpdatedAt,
  };
};

export default useCallInsights;
